// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"820c0c62","559":"80eaea11","989":"d962c81c"}[chunkId] + ".css";
};